__turbopack_context__.v({
  "address": "_3wZhhW_address",
  "addressPin": "_3wZhhW_addressPin",
  "arrowUp": "_3wZhhW_arrowUp",
  "arrowUpIcon": "_3wZhhW_arrowUpIcon",
  "bottom": "_3wZhhW_bottom",
  "bottomContent": "_3wZhhW_bottomContent",
  "buttonAccount": "_3wZhhW_buttonAccount",
  "buttonCall": "_3wZhhW_buttonCall",
  "buttons": "_3wZhhW_buttons",
  "contactsColumn": "_3wZhhW_contactsColumn",
  "contactsLinks": "_3wZhhW_contactsLinks",
  "contactsLogo": "_3wZhhW_contactsLogo",
  "container": "_3wZhhW_container",
  "content": "_3wZhhW_content",
  "copyright": "_3wZhhW_copyright",
  "dark": "_3wZhhW_dark",
  "link": "_3wZhhW_link",
  "logo": "_3wZhhW_logo",
  "logoColumn": "_3wZhhW_logoColumn",
  "logoLink": "_3wZhhW_logoLink",
  "nav": "_3wZhhW_nav",
  "phone": "_3wZhhW_phone",
  "politic": "_3wZhhW_politic",
  "politicLinks": "_3wZhhW_politicLinks",
  "soc": "_3wZhhW_soc",
  "socBackground": "_3wZhhW_socBackground",
  "socIcon": "_3wZhhW_socIcon",
  "socials": "_3wZhhW_socials",
  "top": "_3wZhhW_top",
  "userIcon": "_3wZhhW_userIcon",
});
